<template lang="pug">
  include ../../../pug/mixins/bem
  +b.play-video.A(href='',
                  @click.prevent='openPopupWithVideo')
</template>
<script>
export default {
  name: 'PlayVideo',
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      id: 0
    }
  },
  methods: {
    getId(url) {
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      let match = url.match(regExp)
      //console.log(match)
      if (match && match[2].length == 11) {
        return match[2]
      } else {
        return "error"
      }
    },
    openPopupWithVideo() {
      let interval = 100
      setTimeout(() => {
        this.$modal.show(
          {
            template: `
            <div>
              <iframe :src="url" allowfullscreen="true" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ></iframe>

              <a class="close-popup" @click.prevent='$emit("close")'> &times </a>
            </div>
          `,
            props: ["url"]
          },
          {
            url: `//www.youtube.com/embed/${this.getId(this.url)}?rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&enablejsapi=1`
          },
          {
            height: "auto",
            minWidth: 300,
            maxWidth: 370,
            adaptive: true,
            scrollable: true,
            classes: "videoPopup"
          },
          
        )
      }, interval)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/shared/components/PlayVideo.vue